import React from 'react';
import styled from 'libs/styled';
import Text from 'components/Text';
import Button from 'components/Button';
import type { FooterContactSection } from './types';

const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
`;

const Column = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const Row = styled('div')`
    display: flex;
    border-top: 1px solid var(--stroke-default);
    padding: 16px 0;
`;

const ContactDetails = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const LABEL_TYPOGRAPHY = ['Secondary/Mobile/13_120_400', null, null, null, null, 'Secondary/15_120_400'];
const CONTACT_TYPOGRAPHY = ['Primary/Mobile/13_100_510_-1', null, null, null, null, 'Primary/15_120_510_-1'];

interface ContactSectionsProps {
    sections?: FooterContactSection[];
    isDesktop: boolean;
}

export const ContactSections = ({ sections, isDesktop }: ContactSectionsProps) => {
    if (!sections?.length) return null;

    if (isDesktop) {
        return (
            <Wrapper>
                {sections.map((section) => (
                    <Column key={section.title}>
                        <Text typography={LABEL_TYPOGRAPHY} color="var(--ui-primary-aa)">
                            {section.title}
                        </Text>
                        <ContactDetails>
                            {section.phone && (
                                <Button to={`tel:${section.phone}`} theme="textButton" typography={CONTACT_TYPOGRAPHY}>
                                    {section.phone}
                                </Button>
                            )}
                            {section.email && (
                                <Button
                                    to={`mailto:${section.email}`}
                                    theme="textButton"
                                    typography={CONTACT_TYPOGRAPHY}
                                >
                                    {section.email}
                                </Button>
                            )}
                        </ContactDetails>
                    </Column>
                ))}
            </Wrapper>
        );
    }

    return (
        <>
            {sections.map((section) => (
                <Row key={section.title}>
                    <Text typography={LABEL_TYPOGRAPHY} color="var(--ui-primary-aa)" width="40%" flexShrink="0">
                        {section.title}
                    </Text>
                    <ContactDetails display="flex" flexDirection="column">
                        {section.phone && (
                            <Button to={`tel:${section.phone}`} theme="textButton" typography={CONTACT_TYPOGRAPHY}>
                                {section.phone}
                            </Button>
                        )}
                        {section.email && (
                            <Button to={`mailto:${section.email}`} theme="textButton" typography={CONTACT_TYPOGRAPHY}>
                                {section.email}
                            </Button>
                        )}
                    </ContactDetails>
                </Row>
            ))}
        </>
    );
};
